/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Export_Options_AriaInputs */



/**
* | output |
* | --- |
* | "Drastic Tech Export Options" |
*
* @param {Drastic_Tech_Export_Options_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_export_options_aria = /** @type {((inputs?: Drastic_Tech_Export_Options_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Export_Options_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Options d'export Drastic Tech")
	if (locale === "de") return /** @type {LocalizedString} */ ("Drastische Technologieexportoptionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzioni di esportazione tecnologica drastiche")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Варианты экспорта радикальных технологий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opciones drásticas para la exportación de tecnología")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("激进的技术出口选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("抜本的な技術輸出オプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तकनीकी निर्यात के लिए व्यापक विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opções drásticas de exportação de tecnologia")
	return /** @type {LocalizedString} */ ("Drastic Tech Export Options")
});